(function () {
  const initFooter = (section) => {
    if (!section || document.documentElement.getAttribute("dir") === "rtl")
      return;
    const positionCheckbox = (inputContainer, inputWrapper, checkbox) => {
      const containerLeft = inputContainer.getBoundingClientRect().left;
      const inputLeft = inputWrapper.getBoundingClientRect().left;
      const diff = inputLeft - containerLeft;
      checkbox.style.paddingLeft = `${diff}px`;
    };
    const inputContainer = section.querySelector(
      ".footer-subscribe-form__main"
    );
    const inputWrapper = section.querySelector(
      ".footer-subscribe-form__input-wrapper"
    );
    const checkbox = section.querySelector(".footer-subscribe-form-checkbox");
    if (inputContainer && inputWrapper && checkbox) {
      let sectionWidth = section.getBoundingClientRect().width;
      const observer = new ResizeObserver((entries) => {
        if (entries[0].contentRect.width !== sectionWidth) {
          positionCheckbox(inputContainer, inputWrapper, checkbox);
          sectionWidth = entries[0].contentRect.width;
        }
      });
      document.addEventListener("DOMContentLoaded", () => {
        positionCheckbox(inputContainer, inputWrapper, checkbox);
        observer.observe(section);
      });
    }
  };
  initFooter(document.currentScript.parentElement);
  document.addEventListener("shopify:section:load", function (event) {
    initFooter(event.target);
  });
})();
